import { PagePartHolder } from '../../PagePartHolder';
import PageHeader from '../PageHeader';

export const TitlebarHolder = (props) => {
  return <PagePartHolder {...props} Component={PageHeader} outlet="title" />;
};
